// router.tsx

import React, { Suspense } from "react";
import {
  createBrowserRouter,
  Navigate,
  Outlet,
  useLocation,
} from "react-router-dom";

// Component imports
import Loader from "components/loader";
import Home from "pages/home";
import Error404 from "pages/error-404";
import MonthlyInsights from "pages/monthly-insights";
import Reporting from "pages/reporting";
import BusinessRules from "pages/business-rules";
import DataOrchestration from "pages/data-orchestration";
import Downloads from "pages/downloads";
import JeAccrual from "pages/je-accrual";
import CalculateTaxes from "pages/calculate-taxes";
import UtcMappingRules from "pages/utc-mapping-rules";
import AppProvider from "../App";
import Transactions from "pages/transactions";
import JeAccrualBatchMetadata from "pages/je-accrual-batch-metadata";
import ChatAgentGuard from "./ChatAgentGuard";

const TransactionsGuard: React.FC = () => {
  const location = useLocation();

  if (!location.state?.from?.pathname?.includes("/calculate-taxes")) {
    return <Navigate to="/calculate-taxes" replace />;
  }

  return <Transactions />;
};

// Router Configuration
export const router = createBrowserRouter([
  {
    element: <AppProvider />,
    children: [
      {
        element: (
          <Suspense fallback={<Loader loadingText="Loading..." />}>
            <Outlet />
          </Suspense>
        ),
        children: [
          {
            path: "/",
            element: <Home />,
          },
          {
            path: "/monthly-insights",
            element: <MonthlyInsights />,
          },
          {
            path: "/chat-agent",
            element: <ChatAgentGuard />,
          },
          {
            path: "/reporting",
            element: <Reporting />,
          },
          {
            path: "/business-rules",
            element: <BusinessRules />,
          },
          {
            path: "/business-rules/utc-mapping-rules",
            element: <UtcMappingRules />,
          },
          {
            path: "/data-orchestration",
            element: <DataOrchestration />,
          },
          {
            path: "/downloads/:fileId",
            element: <Downloads />,
          },
          {
            path: "/je-accrual",
            element: <JeAccrual />,
          },
          {
            path: "/je-accrual/batch",
            element: <JeAccrualBatchMetadata />,
          },
          {
            path: "/calculate-taxes",
            element: <CalculateTaxes />,
          },
          {
            path: "/transactions",
            element: <TransactionsGuard />,
          },
          {
            path: "*",
            element: <Error404 />,
          },
        ],
      },
    ],
  },
]);

export default router;
